import Vue from "vue";
import VueGtag from "vue-gtag";
import Router from "vue-router";
import Inicio from "@/pages/Inicio";
import OlvidoContrasena from "@/pages/OlvidoContrasena";
import RecuperarContrasena from "@/pages/RecuperarContrasena";
import Comprobantes from "@/pages/Comprobantes";
import Axios from "@/utils/axiosJWT.js";

Vue.use(Router);

const router = new Router({
  base: CONTEXT,
  mode: "history",
  routes: [
    {
      path: "/",
      name: "Inicio",
      component: Inicio
    },
    {
      path: "/olvido-contrasena",
      name: "OlvidoContrasena",
      component: OlvidoContrasena
    },
    {
      path: "/recuperar-contrasena/:id",
      name: "RecuperarContrasena",
      component: RecuperarContrasena
    },
    {
      path: "/comprobantes-disponibles/:runPostulante",
      name: "Comprobantes",
      component: Comprobantes
    },
    {
      path: "*",
      component: Inicio
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  }
});

router.beforeEach((to, from, next) => {
  if ("Comprobantes" == to.name) {
    if (Vue.$ss.get("jwt", "") == "") {
      next({ name: "Inicio" });
    } else {
      Axios.configurarJWT(Vue.$ss.get("jwt"));
      next();
    }
  } else {
    next();
  }
});

Vue.use(
  VueGtag,
  {
    config: {
      id: GTAG_ANALYTICS_KEY
    }
  },
  router
);

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js